<template>
  <span>
    {{ supportedDevices }}
  </span>
</template>

<script>
import { get } from 'lodash';

export default {
  name: 'AppleVppSupportedDevices',

  props: {
    arrayField: {
      type: String,
      required: true,
    },
    item: {
      default: () => ({}),
      type: Object,
    },
  },

  data() {
    return {
      supportedDevices: this.getFormattedColumnText(),
    };
  },

  methods: {
    getFormattedColumnText() {
      /**
       * This method converts the all capitalized supported Apple Device array
       * we get from the api and formats them properly for display.
       * The first two times this fires off, however, no arrayField is
       * received, so we need to gate this with a fallback "if false then
       * get out of this method".
       */
      const supportedArray = get(this.item, this.arrayField, false);
      if (!supportedArray) {
        return '';
      }
      const formattedArray = supportedArray.map(
        (el) => {
          if (el[0] !== 'I') {
            return el[0].toUpperCase() + el.slice(1).toLowerCase();
          }
          return el[0].toLowerCase() + el[1].toUpperCase() + el.slice(2).toLowerCase();
        },
      ).join(', ');
      return formattedArray;
    },
  },

};
</script>
